import { FormikProps } from "formik";

import { getAllowEditMap, ITEM_STATUS } from "./constants";

export function resetHeaderFormik(formik: FormikProps<NotRefOrderHeader>) {
  const initialValues = formik.initialValues;
  const values = formik.values;
  formik.setValues({
    ...initialValues,
    id: values.id,
    salesOrganizationList: values.salesOrganizationList,
    distributionChannelList: values.distributionChannelList,
    divisionList: values.divisionList,
    salesGroupList: values.salesGroupList,
    paymentTermList: values.paymentTermList,
    billTolist: values.billTolist,
    shipTolist: values.shipTolist,
    unloadingPoints: values.unloadingPoints
  });
}
export function getIndex(itemNo) {
  return +itemNo / 10 - 1;
}
export function getItemByNo(lines, itemNo) {
  return lines.find(line => line.itemNo === itemNo);
}
export function getIndexByItemNo(lines, itemNo) {
  return lines.findIndex(line => line.itemNo === itemNo);
}
function mapInitalData(initiallines, prev, asc) {
  let prevLines = prev.filter(p => !(p.isSplit || p.isNewItem));
  if (!asc) {
    prevLines = prevLines.reverse();
  }
  const res = initiallines.map((line, i) => ({
    ...line,
    id: prevLines[i]?.id,
    parentId: prevLines[i]?.parentId,
    bomUnitQuantity: prevLines[i]?.bomUnitQuantity
  }));
  if (!asc) {
    res.reverse();
  }
  return res;
}
export function resetItemDetailsFormik(formik: FormikProps<any>, asc) {
  const initiallines = formik.initialValues.lines;
  formik.setValues(prev => ({
    ...prev,
    lines: mapInitalData(initiallines, prev.lines, asc)
  }));
}

export const priceDateCheck = (name, isChangeFlow, line) =>
  name === "priceDate" && isChangeFlow && line?.bomFlag && !line?.parentItemNo;

const requestDateCheck = (name, line) =>
  name === "requestDate" && line.itemStatusEn === ITEM_STATUS.COMPLETE_DELIVERY;

export const plantCheck = (name, isChangeFlow, line) =>
  name === "plant" && isChangeFlow && (line?.bomFlag || line?.parentItemNo);

const splitRequestDateCheck = (line, name) =>
  !line.parentItemNo && line?.isSplit && name === "requestDate";

export function applyAllCheck(
  value,
  name,
  orderTypeCashSale,
  currentAction,
  line,
  isChangeFlow
) {
  let result = line[name];
  if (!getAllowEditMap(orderTypeCashSale, name).has(line.itemStatusEn)) {
    if (currentAction === "add") {
      if (!line.parentItemNo && line?.isNewItem) {
        result = value;
      }
    } else if (currentAction === "split") {
      if (splitRequestDateCheck(line, name)) {
        result = value;
      }
    } else if (requestDateCheck(name, line)) {
      if (line.quantity > line.originalQuantity) {
        result = value;
      }
    } else if (
      priceDateCheck(name, isChangeFlow, line) ||
      plantCheck(name, isChangeFlow, line)
    ) {
      return result;
    } else {
      result = value;
    }
  }
  return result;
}

const deriveOtctext = (otc: NotRefOTC) => {
  const showFields = [
    "name1",
    "street1",
    "street2",
    "subDistrict",
    "district",
    "city",
    "postalCode"
  ];
  const check = c => (c === "name1" ? "" : " ");
  return (
    otc.soldToCode +
    " - " +
    showFields.reduce((p, c) => p + (otc?.[c] ? check(c) + otc[c] : ""), "")
  );
};
interface IDeriveShipTo {
  v: any;
  otcV: any;
}
export const deriveShipToBillTo = ({ v, otcV }: IDeriveShipTo) => {
  if (v) {
    return v;
  } else if (otcV) {
    return deriveOtctext(otcV);
  } else {
    return "";
  }
};

export const parseNumber = (v, fb = null) => {
  if (v === undefined) {
    return v;
  }
  if (v) {
    return +v;
  } else {
    return fb;
  }
};
export const getShipToData = (item, formikHeader) => {
  if (item?.shipTo || item?.otcShipTo) {
    return { v: item?.shipTo, otcV: item?.otcShipTo };
  } else {
    return {
      v: formikHeader?.values?.shipTo,
      otcV: formikHeader?.values?.otcShipTo
    };
  }
};
